import React from 'react';
// components
import UserAvatar from '../components/user_avatar';
import Calendar from '../components/calendar';
// imgs
import pic1 from '../imgs/1.jpg';
import pic2 from '../imgs/2.jpg';
import pic3 from '../imgs/3.jpg';
// seed
import {properties} from '../seed/data';

class PropertyItem extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            disableRequestBtn: true,
            showMessage: false,
            message: '',
            sentRequest: false,
            curImgPos: 0,
            imgWidth: null
        }
        this.img_roll = React.createRef();
    }
    toggleRequestBtn (b) {
        this.setState({disableRequestBtn: b})
    }
    onClickSendRequest () {
        this.setState({
            showMessage: true,
            sentRequest: true,
            message: 'Your request has been sent!'
        })
    }
    onClickImgNavLeft () {
        if (this.state.curImgPos > 0) {
            this.setState({curImgPos: this.state.curImgPos-1})
        }
    }
    onClickImgNavRight () {
        if ((this.state.curImgPos+1)*400 < this.state.imgWidth) {
            this.setState({curImgPos: this.state.curImgPos+1})
        }
    }
    componentDidMount () {
        const w = this.img_roll.current.clientWidth
        if (!this.state.curImgPos) {
            this.setState({imgWidth: w});
        }

    }
  render() {
    let n = this.props.match.params.id;
    let p = n <= properties.length ? properties[n] : properties[0];
    
    return (
      <div className="">
        <div className="property-item-imgs">
            <span className={`property-item-imgs-nav-left${(
                this.state.curImgPos) <= 0 ? ' nav-disable' : ''}`}>
                <i className="fas fa-arrow-circle-left fa-2x" onClick={this.onClickImgNavLeft.bind(this)}></i>
            </span>
            <div className="property-item-imgs-container" 
                ref={this.img_roll} 
                style={{transform: `translateX(-${400*this.state.curImgPos}px)`}}>
                <img src={pic1} />
                <img src={pic2} />
                <img src={pic3} />
                <img src={pic1} />
            </div>
            <span className={`property-item-imgs-nav-right${
                ((this.state.curImgPos+1)*400 > this.state.imgWidth) ? ' nav-disable' : ''}`}>
                <i className="fas fa-arrow-circle-right fa-2x" onClick={this.onClickImgNavRight.bind(this)}></i>
            </span>
        </div>
        <div className="container frame">
          {/* <div className="row">
            <div className="col-md-8 offset-md-2">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                  <div className="carousel-item active" data-interval="1000">
                      <img src={pic1} className="d-block w-100" alt="..."/>
                  </div>
                  <div className="carousel-item" data-interval="1000">
                    <img src={pic2} className="d-block w-100" alt="..."/>
                  </div>
                  <div className="carousel-item" data-interval="1000">
                    <img src={pic3} className="d-block w-100" alt="..."/>
                  </div>
                </div>
              </div> 
          </div>*/}
          
          {this.state.showMessage ? <div className="alert alert-success" role="alert">
                    {this.state.message}
                    </div> : null}
          <div className="row">
                    <div className="col-sm-6 col-md-5 col-lg-4 col-xl-3">
                    <div className="card">
                        <div className="card-body">
                            <UserAvatar size="sm" />
                            <hr/>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    School
                                </div>
                                <div className="profile-infobox-detail">
                                    Seneca
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Program
                                </div>
                                <div className="profile-infobox-detail">
                                    PRA
                                </div>
                            </div>
                            <div className="profile-infobox-item flex-space-between">
                                <div className="profile-infobox-label">
                                    Language
                                </div>
                                <div className="profile-infobox-detail">
                                    English, Spanish
                                </div>
                            </div>
                            <div className="profile-infobox-item">
                                <div className="profile-infobox-label">
                                    Description
                                </div>
                                <div className="profile-infobox-detail profile-infobox-description-detail">
                                    Clean and fun. I just do magic 24-7. Abracadabra!
                                </div>
                            </div>
                            <div className="profile-infobox-item">
                                <div className="profile-infobox-label">
                                    Availability
                                </div>
                                <Calendar price={p.price} toggleRequestBtn={this.toggleRequestBtn.bind(this)}/>
                            </div>
                            <div className="profile-infobox-item">
                                <button className="btn btn-primary btn-block btn-recommend"
                                    onClick={this.onClickSendRequest.bind(this)}
                                    disabled={this.state.disableRequestBtn}>{this.state.sentRequest ? "Sent" : "Send Request"}</button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="col-sm-6 col-md-7 col-lg-8 col-xl-9">
                        <h4>{p.address}</h4>
                        <hr/>
                        <div className="row">
                            <div className="col-md-6 flex-space-between p-item-stat"><span>Price</span> <span>${p.price}</span></div>
                            <div className="col-md-6 flex-space-between p-item-stat"><span>Rooms</span><span>3</span></div>
                            <div className="col-md-6 flex-space-between p-item-stat"><span>Walk from College</span> <span>15min</span></div>
                            <div className="col-md-6 flex-space-between p-item-stat"><span>Parking</span><span>2</span></div>
                            <div className="col-md-12 p-item-description">
                                This is a relaxing, romantic and private self-contained space for two. With mountain views this bright, open concept Loft offers a peaceful atmosphere with a deep soaker tub and quality natural linens.
                            </div>
                        </div>
                    </div>
                </div>

        </div>

      </div>
      )
  }
}

export default PropertyItem;